import {
  DUTCH_ABBREV_MONTHS
} from "./chunk-7GPJCWEO.jsx";
import {
  __name,
  __spreadValues
} from "./chunk-DVUTYNGK.jsx";

// src/utils/date/date.ts
var getDutchMediumFormatDate = /* @__PURE__ */ __name(({
  date,
  intlDateTimeFormat
}) => {
  const parts = intlDateTimeFormat.formatToParts(date);
  const formattedParts = parts.map((part) => {
    if (part.type === "month") {
      return `${part.value}.`;
    }
    return part.value;
  });
  return formattedParts.join("");
}, "getDutchMediumFormatDate");
var getCurrentDate = /* @__PURE__ */ __name(() => {
  const now = /* @__PURE__ */ new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}, "getCurrentDate");
var getIntlDate = /* @__PURE__ */ __name(({
  date,
  lang,
  dateFormat = "DD-MM-YYYY",
  options
}) => {
  let sanitizedDate = date;
  if (typeof date === "string") {
    sanitizedDate = date.trim();
  }
  const now = new Date(sanitizedDate);
  const dateTimeOptions = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, dateFormat === "DD-MM-YYYY" && {
    dateStyle: "short"
  }), dateFormat === "MMM-D-YYY" && {
    dateStyle: "medium"
  }), dateFormat === "MMM-DD-YYYY" && {
    day: "2-digit",
    month: "short",
    year: "numeric"
  }), dateFormat === "MMM-YYYY" && {
    month: "short",
    year: "numeric"
  });
  const formattedDate = new Intl.DateTimeFormat(lang, __spreadValues(__spreadValues({}, dateTimeOptions), options));
  if (lang === "nl" && dateFormat !== "DD-MM-YYYY" && !DUTCH_ABBREV_MONTHS.includes(now.getMonth())) {
    return getDutchMediumFormatDate({
      intlDateTimeFormat: formattedDate,
      date: now
    });
  }
  return formattedDate.format(now);
}, "getIntlDate");

export {
  getCurrentDate,
  getIntlDate
};
